import { TransactionRuleCategoryType } from '@/reducers/admin/transactionRulesReducer'
import { adminApiAxios } from '@/api'

export interface PotentialRules {
  count: number
  page: number
  ruleSuggestions: RuleSuggestion[]
}

export interface RuleSuggestion {
  ruleText: string
  ruleType: string
  type: TransactionRuleCategoryType
  transactionCategoryId: number
}
export const listSmartRules = async (userId: number) => {
  try {
    const response = await adminApiAxios.get<PotentialRules>(
      `/finances/api/v1/admin/transactions/smart_rules/${userId}`
    )

    return response.data.ruleSuggestions
  } catch (_) {
    return false
  }
}

export const listLastRanOnDate = async (userId: number) => {
  try {
    const response = await adminApiAxios.get<{ smartRuleLastRan: string }>(
      `/finances/api/v1/admin/transactions/smart_rules/${userId}/last_ran`
    )

    return response.data
  } catch (_) {
    return false
  }
}
